import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=31939e21&"
import script from "./Job.vue?vue&type=script&lang=ts&"
export * from "./Job.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports